import "./HomePage.css";
import {
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import MainPage from "../MainPage/MainPage";
import About from "../About/About";
import ContactMe from "../ContactMe/ContactMe";
import Portfolio from "../Portfolio/Portfolio";
import Academy from "../Academy/Academy";
import Resume from "../Resume/Resume";
import Project from "../Portfolio/Portfolio";
import Banner from "../banner/banner";
function HomePage() {
  const location = useLocation();
  return (
    <div>
      {location.pathname !== '/'? <Navbar></Navbar>:<Banner></Banner>}
      <Switch>
        <Route exact path="/">
          <MainPage />
        </Route>
        <Route exact path="/about">
          <About />
        </Route>
        <Route exact path="/portfolio">
          <Portfolio />
        </Route>
        <Route exact path="/contact">
          <ContactMe />
        </Route>
        <Route exact path="/resume">
          <Resume />
        </Route>
        <Route exact path="/academy">
          <Academy />
        </Route>
        <Route exact path="/project/:id">
          <Project />
        </Route>
      </Switch>
    </div>
  );
}

export default HomePage;
